import { Grid, Skeleton } from "@mui/material";
import { MetaInformationTitleProps } from "../../types";

export default function MetaInformationTitle(props: Readonly<MetaInformationTitleProps>) {
	return (
		<Grid container justifyContent={"space-between"} className="!border-b !border-[#CCC] !py-[20px] !px-[32px]">
			<Grid item>
				<Skeleton variant="text" width={350} height={28} className="!rounded-[6px]" />
			</Grid>
			{props.addons && (
				<Grid item>
					<Skeleton variant="rectangular" width={100} height={28} className="!rounded-[6px]" />
				</Grid>
			)}
		</Grid>
	);
}
